import { PERMISSIONS } from '@/constants/permissions';
import { ORGANIZATION_ROLES } from '@/constants/roles';
import { currentUserIsSuperAdmin, organizationRole } from '@/globalHelpers/userRole';

export default {
  computed: {
    hasStorePermission() {
      if (currentUserIsSuperAdmin()) {
        // Super Admins always bypass org-based checks and permissions,
        // so we can grant access immediately without evaluating orgRole
        // or store-based permissions.
        return true;
      }

      const orgRole = organizationRole();

      if (!orgRole) return false;
      if (organizationRole() === ORGANIZATION_ROLES.ORG_OWNER) return true;

      const permissions = (this.$store.state.admin && this.$store.state.admin.permissions) || [];
      return permissions.includes(PERMISSIONS.SHOP);
    },
  },  
};
